import { useEffect, useState, useRef, useContext, RefObject} from "react";
import { useLocation } from "react-router-dom";
import Conversations from "../Conversations/Conversations";
import DetailsTab from "../DetailsTab/DetailsTab";
import Lapaccordion from "../Lap-accordion/Lap-accordion";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import { get } from "js-cookie";
import { IoChatbubblesSharp } from "react-icons/io5";
import VideoContext from "../../store/video-context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { isEmpty } from 'lodash';
import UpdateProfile from "../UpdateProfile/UpdateProfile";
import SecondaryAdBanner from "../SecondaryAdBanner/SecondaryAdBanner";
import PrimaryAdBanner from "../PrimaryAdBanner/PrimaryAdBanner";
import { concat, isEmpty } from "lodash";
import OutsideClickHandler from "react-outside-click-handler";
import SwitchPopup from "../SwitchPopup/SwitchPopup";
import Walkthrough from "../Walkthrough/Walkthrough";
import { Modal, Button, CloseButton } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useMediaQuery } from 'react-responsive';
import ReactGA from 'react-ga';
import NotificationArea from "../NotificationArea/NotificationArea";


ReactGA.initialize('UA-34761649-1');
const Home = (props: any) => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const vContext = useContext(VideoContext);
  const [data, setData] = useState();
  const myObj: { [index: string]: any } = {};
  const [adPath, setAdPath] = useState([]);
  const [secondaryAdPath, setSecondaryAdPath] = useState([]);
  const [mobileAdPath, setMobileAdPath] = useState([]);
  const [transmissionpptid, setTransmissionpptid] = useState("0");
  const childRef = useRef(myObj);
  const isAdmin = vContext.isAdmin; //props.isAdmin;
  const [showUpdateProfile, setShowUpdateProfile] = useState(false);
  const [show, setShow] = useState(false);
  //const [showKSS, setShowKSS] = useState(true);
  const [adRedirect, setAdRedirect] = useState(useQuery().get("ad_redirect"));
  const [tempTime, setTempTime] = useState(useQuery().get("time"));
  const [openConversation, setOpenConversation] = useState(props.chatSection);
  const playerRef = useRef() as RefObject<HTMLVideoElement>;
  const [time, setTime] = useState(useQuery().get("time"));
  const [chatSection, setChatSection] = useState(false);
  let testdata = [
    {
      image_path: "style/images/ad_images/hospital/medtronic_sonicisionAd.jpg",
      product_name: "test1",
      click: "no",
    },
    {
      image_path: "style/images/ad_images/hospital/medtronic_sonicisionAd.jpg",
      product_name: "test2",
      click: "yes",
    },
    {
      image_path: "style/images/ad_images/hospital/medtronic_sonicisionAd.jpg",
      product_name: "test3",
      click: "no",
    },
  ];

  vContext.setTransIdValue(useQuery().get("trans_id"));
  // vContext.setUserIdValue('1'); // local development




  // Effects declaration Starts
  useEffect(() => {
    let isLoggedIn = get("TestCookie");
    // let isLoggedIn = get('loginUserId');
    // console.log('id',id);
    //admin-1, moderatoe-321, equipment tagger-320, viewer-319 other test 16239 asavari 23661
    if (window.location.hostname === "localhost") {
      isLoggedIn = "318";
    }
    // console.log("origin",window.location.origin);
    vContext.setUserIdValue(isLoggedIn);
    console.log("adRedirect", adRedirect);
    if (adRedirect && adRedirect == "true"

      /*removed redirection hostname as we only need to redirect to www.lapguru.com/lapguru.php?trans_id=*/

      //&& (window.location.hostname == "localhost" || window.location.hostname == "lapguru.com")

    ) {
      window.location.href =
        window.location.origin + "/lapguru.php?trans_id=" + tempTransId;
      // "www.lapguru.com/lapguru.php?trans_id=" + tempTransId;
    }
    if (isLoggedIn) {
      loadUser(tempTransId, isLoggedIn);
      // loadUser(vContext.transId,vContext.userId)
    } else {
      if (tempTime) {
        isLoggedIn = "22818";
        vContext.setUserIdValue(isLoggedIn);
        loadUser(tempTransId, isLoggedIn);
      } else {
        // window.location.href= "https://www.lapguru.com/login/login.php?trans_id="+tempTransId;
        window.location.href =
          window.location.origin + "/login/login.php?trans_id=" + tempTransId;
      }
    }
  }, [vContext.userId, vContext.transId]);
  // Effects declaration Ends

  useEffect(() => {
    // const checkUpdateProfile =(userData: any)=>{
    // console.log('effect userdata',vContext.userData);
    
    ///if (vContext.userData !== {}) {
      if (vContext.userData) {
      let data = vContext.userData;
      data.user_title === "" ||
        data.user_title === null ||
        data.user_title === undefined ||
      data.user_first_name === "" ||
        data.user_first_name === null ||
        data.user_first_name === undefined ||
        data.user_last_name === "" ||
        data.user_last_name === null ||
        data.user_last_name === undefined ||
        data.user_type_id === "1" ||
        data.user_email === "" ||
        data.user_email === null ||
        data.user_email === undefined ||
        data.user_phone_no === "" ||
        data.user_phone_no === null ||
        data.user_phone_no === undefined ||
        data.country_code === "" ||
        data.country_code === null ||
        data.country_code === undefined ||
        data.user_city === "" ||
        data.user_city === null ||
        data.user_city === undefined ||
        data.user_hospital_name === "" ||
        data.user_hospital_name === null ||
        data.user_hospital_name === undefined ||
        data.user_state === "" ||
        data.user_state === null ||
        data.user_state === undefined ||
        data.user_country === "" ||
        data.user_country === null ||
        data.user_country === undefined ||
        data.user_interest === "" ||
        data.user_interest === null ||
        data.user_interest === undefined ||
        data.user_qualification === "" ||
        data.user_qualification === null ||
        data.user_qualification === undefined ||
        data.user_specialisation === "" ||
        data.user_specialisation === null ||
        data.user_specialisation === undefined ||
        ((data.user_type_id !=5 && data.user_type_id!=6 && data.user_type_id!=8) &&(data.user_mci_no === "" ||
        data.user_mci_no === null ||
        data.user_mci_no === undefined))
        ? // )? console.log(true) : console.log(false);
        setShowUpdateProfile(true)
        : setShowUpdateProfile(false);
    }
  }, [vContext.userData]);
  // }
  const tempTransId = useQuery().get("trans_id");

  useEffect(() => {
    window.addEventListener('resize', e => {
      console.log("sssr")
      if (document.getElementById("conversation")) {
        if (document.fullscreenElement) {
          document.getElementById("conversation")!.style.height = "60vh"//"calc(100vh - 54px - 45px - 80px)";//(window.innerHeight - 54 - 45 - 80 )+ "px";
        } else {
          if (document.getElementById("primaryAd")) {
            document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - document.getElementById("primaryAd")!.clientHeight - 45) + "px";
          } else {
            document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - 25) + "px";
          }
        }
      }
    });
   /*setInterval(() =>
      getViewerCount(tempTransId),
      60000)*/
    ReactGA.pageview(window.location.pathname + window.location.search);

  }, []);

  useEffect(() => {
  
    // console.log('test....', vContext.userData)
  
  }, [vContext.userData]);
  // Function defination Starts

  const openChats = () => {
    setChatSection(!chatSection);
    // console.log('open chats');
  };
  const closeChats = () => {
    setChatSection(false);
  };
  const loadUser = (transId: any, userId: any) => {
    // console.log('loadUser');
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=getUserData&userID=" +
      userId
    )
      .then((res) => res.json())
      .then((userData) => {
        // console.log('userData',userData);
        if (userData.status === "success") {
          // toast("Wow so easy !");
          // userData.data[0].user_phone_no = '';
          // userData.data[0].user_specialisation = '';
          // userData.data[0].user_country = '';
          // userData.data[0].user_interest = '';
          vContext.setUserDataHandler(userData.data[0]);
          // checkUpdateProfile(userData.data[0]);

          if (tempTime) {
            loadVideoData(transId, userId);
          } else {
            checkUserHasVideoAccess(transId, userId);
          }

        } else {
          // console.log("Fail load user");
        }
      })
      .catch((error) => {
        console.error("Error:(loadUser)", error);
      });
  };

  const checkUserHasVideoAccess = (transId: any, userId: any) => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=checkUserVideoAccess&transID=" +
      transId +
      "&userID=" +
      userId
    )
      .then((res) => res.json())
      .then((accessData) => {
        // console.log('accessData',accessData)
        if (accessData.status === "success") {
          if (accessData.data[0].video_access == "yes") {
            loadVideoData(transId, userId);
          } else {
            // window.location.href =
            //   "https://www.lapguru.com/include/videoAccessPopup.php";
            window.location.href =
             // window.location.origin + "/include/videoAccessPopup.php";
             window.location.origin + accessData.data[0].redirect_url;
          }
        } else {
          // console.log("Fail access check")
        }
      })
      .catch((error) => {
        console.error("Error:(checkUserHasVideoAccess)", error);
      });
  };

  const getUserAgent = () => {
    var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return (
          navigator.userAgent.match(/IEMobile/i) ||
          navigator.userAgent.match(/WPDesktop/i)
        );
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };

    if (isMobile.any()) {
      return "mobile";
    } else {
      return "pc";
    }
  };
  const getViewerCount = (transId: any) => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=getViewersCount&transID=" +
      transId
    )
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log('Response', result.data[0]);
          vContext.setViewCountHandler(result.data);
        },
        (error) => {
          // console.log('Response', error);
          //setData(error);
        }
      );
  }

  const loadVideoData = (transId: any, userId: any) => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=getVideoData&transID=" +
      transId +
      "&userID=" +
      userId
    )
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log('Response', result.data[0]);
          let data = result.data[0];
          if (data.txData[0].tx_speciality !== data.userData.speciality_id) {
            // window.location.href= "www.lapguru.com/include/diffSpecialityPopup.php?user_speciality="+data.userData.speciality_id+"&tx_speciality="+data.txData[0].tx_speciality;
          }
          setData(data);
          vContext.setVideoDataHandler(data);
          setTransmissionpptid(data.txData[0].transmission_ppt_id);
          setAdPath(result.data[0].ad_path);
          // if (getUserAgent() === "pc") {
          setSecondaryAdPath(result.data[0].secondary_ad_path);
        
          // let finalAd: [];
          let a1: [] = result.data[0].ad_path;
          let a2: [] = result.data[0].secondary_ad_path;
     
          // var finalAd: [] = [...result.data[0].ad_path, ...result.data[0].secondary_ad_path]
          var finalAd = [...a1, ...a2]
          setMobileAdPath(finalAd);
          // } else {
          //   let advArray: any = [];
          //   result.data[0].ad_path.map((item: any) => {
          //     let newItem = item;
          //     newItem.image_path = newItem.mobile_image_path;
          //     delete newItem.mobile_image_path;
          //     advArray.push(newItem);
          //   });

          //   advArray.push(...result.data[0].secondary_ad_path);
          //   setSecondaryAdPath(advArray);
          //   // console.log("mobile view data", advArray);
          // }
          vContext.setEquipmentListDataHandler(result.data[0].tagEquipmentList);
          vContext.setAccordionDataHandler(result.data[0].taggedPoints);
          if (data.txData[0].youtube_flag === "1") {
            vContext.setIsYoutubeHandler(true);
          }
          let tagData: any;
          if (data.txData[0].transmission_ppt_id == "1") {
            tagData = {
              topics: [],
              instruments: result.data[0].equipmentList,
            };


          } else {
            tagData = {
              instruments: result.data[0].equipmentList,
              steps: result.data[0].indexsteps,
              anatomy: result.data[0].anatomyList,

            };


          }


          vContext.setUserRoleHandler(result.data[0].userData[0].user_role);
          result.data[0].userData[0].user_role === "admin"
            ? vContext.setIsAdminHandler(true)
            : vContext.setIsAdminHandler(false);
          vContext.setTagDataHandler(tagData);
          vContext.setIsLoaderActiveHandler(false);
          console.log("loading completed")
if(data.txData[0].transmission_status == 1)
{
          setInterval(() => {
            getViewerCount(transId);
        }, 60000);

      }


        },
        (error) => {
          // console.log('Response', error);
          //setData(error);
        }
      );
    getViewerCount(transId);

  };

  const seekVideoHandler = (time: any) => {
    childRef.current.seekVideo(time);
  };

  const getYTPCurrentTime = () => {
    return childRef.current.getYTCurrentTime();
  };

  const clickedOnAd = (productName: any) => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveProductEnquiry&transID=" +
      vContext.transId +
      "&userID=" +
      vContext.userId +
      "&productName=" +
      productName
    )
      .then((res) => res.json())
      .then((productEnquiryResponse) => {
        // console.log('productEnquiryResponse', productEnquiryResponse);
        if (productEnquiryResponse.status === "success") {
          // console.log("product enquiry details captured!")
        } else {
          // console.log("product enquiry failed");
        }
      })
      .catch((error) => {
        console.error("Error:(clickedOnAd)", error);
      });
  };
  const closeAdModal = () => {
    setShow(false);
    //setShowKSS(false);
  };

  const hideUpdateProfile = () => {
    setShowUpdateProfile(false);
  }
  const handleShow = () => setShow(true);
  const isLandscape = useMediaQuery({ query: '(orientation: landscape)' });
  // Function defination Starts


  // Actual component HTML Starts
  return (
    <>
      {data && vContext.accordionData && (
        <>
          {console.log("data...", data)}
          <ToastContainer />
          <div
            className={
              "container-fluid main-container py-3" +
              (isAdmin ? " admin-page" : "") +
              (vContext.isVideoFullscreen ? " video-full-screen" : "")
            }
          >
            {console.log("yes" + vContext.videoData.player_login)}
            
            {/* <Modal show={showKSS} id="kssimg" onHide={closeAdModal}><CloseButton id="kss-close-btn" onClick={closeAdModal} /><img src={window.location.origin + "/style/images/ad_images/Masicon-POP-up.png"} /></Modal> */}
            <Helmet>

              {/* <title>My Title</title> */}
              <meta charSet="utf-8" />
              <link rel="icon" href="../style/images/lapguru.ico" />
              <meta name="viewport" content="width=device-width, initial-scale=1" />
              <meta name="theme-color" content="#000000" />
              <meta name="description" content="test description" />
              <link rel="apple-touch-icon" href="../style/images/lapguru.ico" />

              <meta property="og:url" content={window.location.href} />
              <meta property="og:type" content="website" />
              <meta property="og:title" content="LIVE Event- Power of Surgical Robotics" />
              <meta property="og:description" content="LIVE Event- Power of Surgical Robotics" />
              <meta property="og:image" content="https://lapguru.com/surgeryTV/assets/images/dr_photo/default_surgeon.png" />
              {/* <meta name="description" content="Helmet application" /> */}
            </Helmet>

            <div className="row">

              {/* {(vContext.accordionData.length > 0 || vContext.equipmentList.length > 0)&& */}
              <div className="col-lg-3 pr-lg-0 left-section">
                {window.innerWidth < 992 && (
                  <>
                    {isAdmin ? (
                      <></>
                    ) : mobileAdPath.length > 0 ? (

                      // <SecondaryAdBanner data={finalSecondaryAdPath} />
                      <>
                        <SecondaryAdBanner
                          data={mobileAdPath}
                        />
                        <NotificationArea />
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                )}
                <Lapaccordion seekVideo={seekVideoHandler} data={data} isAdmin={isAdmin} />
              </div>
              {/* } */}
              {/* <div className={`${(vContext.accordionData.length > 0 || vContext.equipmentList.length > 0)? "col-lg-7 offset-lg-2":"col-lg-9"} main-video-container`}> */}
              <div className={"col-lg-6 offset-lg-3 main-video-container"}>
                {window.innerWidth > 991 && (
                  <>
                    {isAdmin ? (
                      <></>
                    ) : secondaryAdPath.length > 0 ? (
                      <SecondaryAdBanner data={secondaryAdPath} />
                    ) : (
                      <></>
                    )}
                  </>
                )}
                {
                  <VideoPlayer
                    ref={childRef}
                    videoData={data}
                    closeChats={closeChats}
                  //     playsInline
                  />
                }

                {transmissionpptid === "0" && <DetailsTab tabData={data} />}
                {isAdmin ? (
                  <></>
                ) : window.innerWidth <= 992 ? (
                  mobileAdPath.length > 0 && (
                    <SecondaryAdBanner data={mobileAdPath} />
                  )
                ) : secondaryAdPath.length > 0 && (
                  <SecondaryAdBanner data={secondaryAdPath} />
                )}
              </div>
              <div
                className={`col-lg-3 pl-lg-0 right-section
                ${chatSection ? " show" : ""}
                  ${adPath.length < 1 ? " noads" : ""}`}
              >
                <NotificationArea />
                {adPath.length > 0 && <PrimaryAdBanner data={adPath} />}
                {vContext.isVideoFullscreen ? <>
                  {isLandscape ? "" :
                    <div className="chat-open-btn d-lg-none" onClick={openChats}>
                      <IoChatbubblesSharp size={30} />
                    </div>
                  }
                </>
                  :
                  <div className="chat-open-btn d-lg-none" onClick={openChats}>
                    <IoChatbubblesSharp size={30} />
                  </div>
                }
                {vContext.isVideoFullscreen ? (
                  <>
                    <Conversations
                      chats={data}
                      isAdmin={isAdmin}
                      getYTCurrentTime={getYTPCurrentTime}
                      toggleChat={openChats}
                      seekVideo={seekVideoHandler}
                    />
                  </>
                ) : (
                  <>


                    <OutsideClickHandler
                      onOutsideClick={() => {
                        setChatSection(false);
                      }}
                    >
                      <Conversations
                        chats={data}
                        isAdmin={isAdmin}
                        getYTCurrentTime={getYTPCurrentTime}
                        toggleChat={openChats}
                        seekVideo={seekVideoHandler}
                      />
                    </OutsideClickHandler>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* {showUpdateProfile && <UpdateProfile />} */}
          {showUpdateProfile == true ? <UpdateProfile setUpdateProfile={hideUpdateProfile} /> : <Walkthrough />}
        </>
      )}

      {vContext.isVideoFullscreen ? (
        ""
      ) : (
        <>
          {vContext.isYoutube ? (
            ""
          ) : (
            <div className="switchToOld-btn">
              {vContext.isLoaderActive === false && <Button onClick={handleShow} id="switchToOld">
              Report Issues
              </Button>}
              <Modal show={show} onHide={closeAdModal}>
                <SwitchPopup hide={closeAdModal} />
              </Modal>
            </div>
          )}
        </>
      )}
    </>
  );
  // Actual component HTML Ends
};

export default Home;
